export default 'https://storage.googleapis.com/hom-frontend-assets/next/assets/drill/the-multiplication-table.svg'
